import { Injectable } from "@angular/core";

import { LgApplicationInsightsService } from "@logex/framework/lg-application";

export interface IApplicationInsighsTracer {
    trackEvent(category: string, action: string, label?: string, value?: number | string);
}

@Injectable({ providedIn: "root" })
export class ApplicationInsightsServiceExt
    extends LgApplicationInsightsService
    implements IApplicationInsighsTracer
{
    trackEvent(category: string, action: string, label?: string, value?: number | string): void {
        if (
            this.appInsights?.config.instrumentationKey != null &&
            this.appInsights?.config.instrumentationKey !== ""
        )
            this.appInsights.trackEvent({
                name: `${category} - ${action}`,
                properties: {
                    category,
                    action,
                    label,
                    value
                }
            });
    }
}
